module.exports = __webpack_public_path__ + "img/lesson_01.9c945957.jpg";